import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SIGNAL_STORE_CUSTOMER_HEADER, SIGNAL_STORE_CUSTOMER_ID } from './signal-store-customer-context';

/**
 * Applies customer context from signal-store resource requests.
 *
 * If `SIGNAL_STORE_CUSTOMER_ID` is present in request context, this interceptor sets
 * the `Next-CustomerId` request header to that value.
 *
 * This is required for feature signal stores because resource requests can react to
 * customer changes before/independent from global app-level customer interceptor state.
 */
@Injectable()
export class SignalStoreCustomerInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const customerId = req.context.get(SIGNAL_STORE_CUSTOMER_ID);

    if (customerId === null) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: {
          [SIGNAL_STORE_CUSTOMER_HEADER]: customerId.toString(),
        },
      }),
    );
  }
}
